export default "__VITE_ASSET__be92afc4__"